export enum AlertTypes {
    SNACKBAR_SUCCESS = "SNACKBAR_SUCCESS",
    SNACKBAR_HIDE = "SNACKBAR_HIDE",
    SNACKBAR_CLEAR = "SNACKBAR_CLEAR",
}
